const digits = [0,1,2,3,4,5,6,7,8,9];

export const generateCode = (length = 5) => {
  let code = '', randomIndex;
  for ( let i=0; i<length; i+=1 ) {
    randomIndex = Math.round((Math.random()*(digits.length - 1)));
    code += String(digits[randomIndex]);
  }
  return code;
};



// WEBPACK FOOTER //
// ./src/module/Codes.js